import { Flex } from 'antd'
import React, { CSSProperties } from 'react'
import { styled } from 'styled-components'
import { DesignSystem } from '~/core/designSystem'

const Item = styled.div<{ $isActive: boolean }>`
  flex: 1;
  height: 4px;

  ${props => {
    if (props.$isActive) {
      return `background: ${DesignSystem.ThemeConst.PRIMARY_YELLOW};`
    }

    return `background: ${DesignSystem.ThemeConst.CONSUMER_LIGHTGREY};`
  }}
`

type Props = {
  count: number
  index: number
  className?: string
  style?: CSSProperties
}

export const Stepper: React.FC<Props> = ({
  count,
  index: indexActive,
  className = '',
  style = {},
}) => {
  const items = new Array(count).fill(null)

  return (
    <>
      <Flex
        className={`w-full py-4 ${className}`}
        style={{ background: 'white', maxWidth: '600px', ...style }}
        align="center"
        vertical
      >
        <Flex
          className="w-full"
          gap={8}
          style={{
            maxWidth: '600px',
          }}
        >
          {items.map((_, index) => (
            <Item key={index} $isActive={index <= indexActive} />
          ))}
        </Flex>
      </Flex>
    </>
  )
}
